module.exports = __webpack_public_path__ + "assets/67.jpg?0f009026daa99305e0fb7335717a1594";